import React from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Button, Heading, TextButton } from '@wix/design-system';
import { ChevronLeft } from '@wix/wix-ui-icons-common/odeditor';
import { WIX_STUDIO_HEADER_HEIGHT } from '@wix/core-domain-search';
import { DomainSearchSuiteModule, EntriIntroModalBody, EntriIntroModalFooter, EntriModule } from '@wix/domains-search-suite';
import { useQueryParams } from '../../hooks/useQueryParams';
export const ConnectIntroRoute = _ref => {
  let {
    onConnectEntri,
    onConnectManual,
    onBack
  } = _ref;
  const {
    getQueryParam
  } = useQueryParams();
  const domainName = getQueryParam('domainName') ?? undefined;
  const metaSiteId = getQueryParam('metaSiteId') ?? undefined;
  const siteName = getQueryParam('siteName') ?? undefined;
  const takenInAnotherAccount = getQueryParam('takenInAnotherAccount') === 'true';
  if (!domainName || !metaSiteId) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    }
  }, /*#__PURE__*/React.createElement(ConnectIntroContent, {
    domainName: domainName,
    metaSiteId: metaSiteId,
    siteName: siteName,
    takenInAnotherAccount: takenInAnotherAccount,
    onConnectEntri: onConnectEntri,
    onConnectManual: onConnectManual,
    onBack: onBack
  }));
};
const ConnectIntroContent = _ref2 => {
  let {
    domainName,
    metaSiteId,
    siteName,
    takenInAnotherAccount,
    onConnectEntri,
    onConnectManual,
    onBack
  } = _ref2;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  const {
    domainTakenInWixEntriModal
  } = EntriModule.internals.domainsEntriModalsController;
  const onManualFlow = () => {
    if (takenInAnotherAccount) {
      domainTakenInWixEntriModal.show({
        connectHandler: async () => {
          domainTakenInWixEntriModal.hide();
          await (onConnectEntri == null ? void 0 : onConnectEntri({
            domainName,
            metaSiteId,
            siteName,
            takenInAnotherAccount
          }));
        }
      });
      return;
    }
    onConnectManual == null || onConnectManual({
      domainName,
      metaSiteId
    });
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    height: `calc(100dvh - ${WIX_STUDIO_HEADER_HEIGHT})`
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "SP3",
    flex: "0 0 auto"
  }, /*#__PURE__*/React.createElement(TextButton, {
    skin: "dark",
    prefixIcon: /*#__PURE__*/React.createElement(ChevronLeft, null),
    onClick: () => onBack == null ? void 0 : onBack({
      domainName,
      metaSiteId
    })
  }, t('entri.intro_modal.back_cta'))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: "1 1 auto",
    align: "center",
    verticalAlign: "top",
    padding: "SP1 SP4"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: "center",
    textAlign: "center",
    width: "100%",
    maxWidth: "384px"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large"
  }, t('entri.intro_modal.title', {
    domainName,
    siteName
  })), /*#__PURE__*/React.createElement(Box, {
    marginTop: "SP6"
  }, /*#__PURE__*/React.createElement(EntriIntroModalBody, {
    domainName: domainName,
    gap: "SP6",
    iconGap: "18px"
  })), /*#__PURE__*/React.createElement(Box, {
    marginTop: "SP6",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    fullWidth: true,
    onClick: () => onConnectEntri == null ? void 0 : onConnectEntri({
      domainName,
      metaSiteId,
      siteName,
      takenInAnotherAccount
    })
  }, t('entri.intro_modal.primary_cta'))))), /*#__PURE__*/React.createElement(Box, {
    display: "block",
    textAlign: "center",
    padding: "SP4",
    flex: "0 0 auto",
    backgroundColor: "#F5F5F5"
  }, /*#__PURE__*/React.createElement(EntriIntroModalFooter, {
    domainName: domainName,
    centered: true,
    onManualFlow: onManualFlow
  })));
};
//# sourceMappingURL=ConnectIntroRoute.js.map